import { combineReducers } from 'redux';
import byFilters from './byFilters';
import byId from './byId';

export default combineReducers({
  byFilters,
  byId,
});
